module.exports = __webpack_public_path__ + "img/open.ac8b4777.png";